import { Box, BoxProps, HeadingProps } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';

import { H1 } from '@/components/Heading';

type PageTitleProps = {
    title: string;
    boxProps?: BoxProps;
    headingProps?: HeadingProps;
};

export const PageTitle = (props: PageTitleProps) => {
    const { title, headingProps, boxProps } = props;
    return (
        <Box textAlign="center" mb="14" {...boxProps}>
            <H1 mb={0} {...headingProps}>
                <FormattedMessage id={title} defaultMessage={title} />
            </H1>
        </Box>
    );
};
